import { NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { CURRENT_PIPELINE, Pipeline } from '@vendasta/sales-common';
import {
  SALES_UI_OPPORTUNITY_CONFIG_TOKEN,
  SalesUIOpportunityConfig,
  BUSINESS_INFO_SERVICE_TOKEN,
  SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN,
  SALES_UI_CREATE_OPPORTUNITY_CONFIG_TOKEN,
  SALES_PERSON_ID_TOKEN,
  PIPELINES_TOKEN,
} from './tokens';
import { SALESPERSON_ID_TOKEN } from '../meddic/meddic-section/meddic-notes/meddic-notes-field/meddic-notes-field.component';
import {
  BusinessInfoService,
  OpportunityBusinessService,
} from './opportunity-side-panel/business-service/opportunity-business.service';
import { OpportunityServiceModule } from './opportunity-service.module';
import { ActivitiesTimelineService } from '@galaxy/crm/static';
import { RxState } from '@rx-angular/state';

@NgModule({
  declarations: [],
  exports: [],
  providers: [
    OpportunityBusinessService,
    { provide: SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN, useExisting: SALES_UI_OPPORTUNITY_CONFIG_TOKEN },
    { provide: SALES_UI_CREATE_OPPORTUNITY_CONFIG_TOKEN, useExisting: SALES_UI_OPPORTUNITY_CONFIG_TOKEN },
    { provide: SALES_PERSON_ID_TOKEN, deps: [SALES_UI_OPPORTUNITY_CONFIG_TOKEN], useFactory: salesPersonIdFactory },
    { provide: PIPELINES_TOKEN, deps: [SALES_UI_OPPORTUNITY_CONFIG_TOKEN], useFactory: pipelinesFactory },
    { provide: CURRENT_PIPELINE, deps: [SALES_UI_OPPORTUNITY_CONFIG_TOKEN], useFactory: currentPipelineFactory },
    { provide: SALESPERSON_ID_TOKEN, deps: [SALES_UI_OPPORTUNITY_CONFIG_TOKEN], useFactory: salesPersonIdFactory },
    {
      provide: BUSINESS_INFO_SERVICE_TOKEN,
      deps: [SALES_UI_OPPORTUNITY_CONFIG_TOKEN],
      useFactory: businessInfoServiceFactory,
    },
    ActivitiesTimelineService,
    RxState,
  ],
  imports: [OpportunityServiceModule],
})
export class OpportunityModule {}

function pipelinesFactory(config: SalesUIOpportunityConfig): Observable<Pipeline[]> {
  return config.pipelines$;
}
function salesPersonIdFactory(config: SalesUIOpportunityConfig): Observable<string> {
  return config.salespersonId$;
}

function currentPipelineFactory(config: SalesUIOpportunityConfig): Observable<Pipeline> {
  return config.currentPipeline$;
}

function businessInfoServiceFactory(config: SalesUIOpportunityConfig): BusinessInfoService {
  return config.businessInfoService;
}
